module.exports = App.Banner = DS.Model.extend
  created_at:      DS.attr 'date'
  updated_at:      DS.attr 'date'

  organization:    DS.belongsTo 'organization', async: true

  name:            DS.attr 'string'
  url_web:         DS.attr 'string'
  url_mobile:      DS.attr 'string'
  kind:            DS.attr 'mixed'
  view_order:      DS.attr 'number'

  photo:           DS.attr 'mixed'

  is_archived:     DS.attr 'boolean'


  #popup fields
  has_clickable_popup: DS.attr 'boolean'
  has_popup_on_start:  DS.attr 'boolean'
  popup_with_image:    DS.attr 'boolean'
  popup_is_blocking:   DS.attr 'boolean'
  title:               DS.attr 'string'
  content:             DS.attr 'string'
  cancel_button:       DS.attr 'string'
  confirm_button:      DS.attr 'string'

  actual_from:     DS.attr 'date'
  actual_till:     DS.attr 'date'

  restaurants:     DS.hasMany   'restaurant',   async: true

  uploadPhoto: (file) ->
    promise = @fileUpload("photo", file)
    promise.then => @notifyRecordChange()
    promise

  cardBackgroundStyle: (->
    photo = @get('photo.medium')
    result = if photo then "background-image:  url(#{photo});" else ''
    result.htmlSafe()
  ).property('photo.medium_square')

  selectedKinds: (->
    currentKinds = @get('kind') || []
    currentKinds.map (kind) ->
      {id: kind, name: Em.I18n.t "banners.main.kind.#{kind}"}
  ).property('banner.kind')
